import Greet from './Greet'
export default Greet
